import React from 'react';
import App from 'next/app';
import ContentLayout from '../src/components/Layout/ContentLayout';
import * as Analytics from 'blueprint/components/analytics';
import '../src/scss/reset.scss';

function ContentApp({ Component, pageProps }) {
  return (
    <Analytics.Provider>
      <ContentLayout {...pageProps}>
        <Component {...pageProps} />
      </ContentLayout>
    </Analytics.Provider>
  );
}

ContentApp.getInitialProps = async (appContext) => {
  const appProps = await App.getInitialProps(appContext);

  return { ...appProps };
};

export default ContentApp;
